import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CommonService } from 'app/Common/common.service';
import { AuthTokenService } from 'app/core/auth/auth-token.service';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { catchError, map, of, switchMap } from 'rxjs';

/**
 * Unknown URLs: login if session expired, otherwise dashboard.
 * Ensures getUserByToken + menu load before redirect (soft nav skips APP_INITIALIZER).
 */
export const unknownRouteGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authTokenService = inject(AuthTokenService);
  const commonService = inject(CommonService);
  const navigationService = inject(NavigationService);

  return authTokenService.ensureValidAccessToken().pipe(
    switchMap((authenticated) => {
      const hasSession =
        authenticated || authTokenService.hasValidRefreshToken();

      if (!hasSession) {
        return of(router.createUrlTree(['/login']));
      }

      const loadUser$ = authTokenService.accessToken
        ? commonService.getUserByToken().pipe(catchError(() => of(null)))
        : of(null);

      return loadUser$.pipe(
        switchMap(() =>
          navigationService.get().pipe(
            map(() => router.createUrlTree(['/dashboard'])),
            catchError(() => of(router.createUrlTree(['/dashboard'])))
          )
        )
      );
    })
  );
};
